const PALETTE = ['blue', 'green', 'gold', 'purple', 'magenta', 'volcano', 'orange', 'geekblue', 'lime', 'cyan'];

export function getBspTagColor(tag: string): string {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) hash = (hash * 31 + tag.charCodeAt(i)) & 0xffff;
  return PALETTE[hash % PALETTE.length];
}
